/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_F8Inputs */

const en_wc_tut_keys_f8 = /** @type {(inputs: Wc_Tut_Keys_F8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend the selection`)
};

/**
* | output |
* | --- |
* | "Extend the selection" |
*
* @param {Wc_Tut_Keys_F8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_f8 = /** @type {((inputs?: Wc_Tut_Keys_F8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_F8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_f8(inputs)
});
export { wc_tut_keys_f8 as "wc.tut.keys.f8" }